import {createAction, props} from '@ngrx/store';

export const setOrganisations: any = createAction(
  '[Set] Organisations',
  props<{ organisations: string[] }>()
);
